import React, { Component } from 'react';
import $ from 'jquery'
import { Link } from 'react-router-dom';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import * as Common from '../CommonControlls/CommonJs';


class NoPageFound extends Component {
constructor(props) {
  super(props);
  this.state = {

  };
}

render(){

return(
<>
  <MainLayout/>
  <div id="right-panel" class="right-panel">
    <Topmenu PageTitle="" isShowAddBtn={false} AddBtnLabel="" AddBtnLink=""/>
    <div class="content">
        <div className="PageLoder"><div style={{fontSize: "18px",minWidth:"420px"}}>Functionalities have been enabled on mobile app, please download the app.</div></div>
    </div>
  </div>
</>  
)}

}
export {NoPageFound as default}
